import { Container, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import React, { useState } from "react";

type ChangeEvent =
  | React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
  | undefined;

type TextFieldsContainerProps = {
  setDowTasks: any;
  DowTasks: any;
  setTitleText: any;
};

const TextFieldsContainer: React.FC<TextFieldsContainerProps> = ({
  setDowTasks,
  DowTasks,
  setTitleText,
}) => {
  const { t } = useTranslation();

  const Dow: any = Object.entries(
    t("image.dayOfTheWeekArr", { returnObjects: true })
  );
  const WeekEnd: any = Object.entries(
    t("image.weekEndArr", { returnObjects: true })
  );

  const changeTask: ChangeEvent = (event) => {
    const ArrNum = Number(event.target.name);
    let newDowTasksTemp = []; //コピー用配列作成
    for (let i = 0; i < 7; i++) {
      newDowTasksTemp.push(DowTasks[i]);
    }
    newDowTasksTemp[ArrNum] = event.target.value;
    setDowTasks(newDowTasksTemp);
  };

  const changeTitle = (e: any) => {
    setTitleText(e.target.value);
  };

  return (
    <div>
      <TextField
        type="text"
        variant="outlined"
        fullWidth
        color="primary"
        size="small"
        label={t("image.title")}
        sx={{ marginBottom: "30px" }}
        onChange={changeTitle}
        defaultValue="sample title"
      />
      {React.Children.toArray(
        Dow.map((value: any, index: number) => (
          <TextField
            type="text"
            variant="outlined"
            fullWidth
            margin="dense"
            color="primary"
            name={`${index}`}
            label={t("image.dayOfTheWeekArr", { returnObjects: true })[index]}
            key={index}
            onChange={changeTask}
            value={DowTasks[index]}
            size="small"
          />
        ))
      )}
      {React.Children.toArray(
        WeekEnd.map((value: any, index: number) => (
          <TextField
            type="text"
            variant="outlined"
            fullWidth
            margin="dense"
            name={`${index + 5}`}
            label={t("image.weekEndArr", { returnObjects: true })[index]}
            key={index}
            onChange={changeTask}
            value={DowTasks[index + 5]}
            size="small"
          />
        ))
      )}
    </div>
  );
};

export default TextFieldsContainer;
